const isLocalhost = Boolean(
	window.location.hostname === 'localhost' ||
		// [::1] is the IPv6 localhost address.
		window.location.hostname === '[::1]' ||
		// 127.0.0.1/8 is considered localhost for IPv4.
		window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

export function register(config?: any) {
	if (import.meta.env.PROD && 'serviceWorker' in navigator) {
		// The URL constructor is available in all browsers that support SW.
		const publicUrl = new URL('./', window.location.href);
		if (publicUrl.origin !== window.location.origin) {
			// Our service worker won't work if PUBLIC_URL is on a different origin
			// from what our page is served on. This might happen if a CDN is used to
			// serve assets; see https://github.com/facebook/create-react-app/issues/2374
			return;
		}

		window.addEventListener('load', () => {
			const swUrl = `./sw.js`;
			if (isLocalhost) {
				// This is running on localhost. Let's check if a service worker still exists or not.
				checkValidServiceWorker(swUrl, config);

				// Add some additional logging to localhost, pointing developers to the
				// service worker/PWA documentation.
				navigator.serviceWorker.ready.then(() => {
					console.log(
						'This web app is being served cache-first by a service ' +
							'worker. To learn more, visit http://bit.ly/CRA-PWA',
					);
				});
			} else {
				// Is not localhost. Just register service worker
				registerValidSW(swUrl, config);
			}
		});
	}
}

const PAGE_LOADED_AT = Date.now();

/** nom du bundle principal chargé par CETTE page (index-xxxx.js) */
function ownBundle(): string | null {
	const s = document.querySelector<HTMLScriptElement>('script[src*="assets/index-"]');
	const src = s ? s.getAttribute('src') || '' : '';
	return src ? src.split('/').pop() || null : null;
}

/** la page affichée est-elle déjà la dernière version ? (son bundle figure dans le sw.js du serveur) — hors ligne : oui, on ne touche à rien */
async function pageIsCurrent(swUrl: string): Promise<boolean> {
	const mine = ownBundle();
	if (!mine) return false;
	try {
		const r = await fetch(swUrl, { cache: 'no-store' });
		if (!r.ok) return true;
		return (await r.text()).includes(mine);
	} catch {
		return true;
	}
}

function registerValidSW(swUrl: string, config: any) {
	// #224b puis 16.10 : quand une nouvelle version prend le contrôle,
	//  - la page est déjà à jour (index.html vient du réseau) → rien ;
	//  - la page est périmée et vient d'être ouverte (< 20 s) → on recharge une fois, tout de suite ;
	//  - la page est périmée et on y travaille → avis « nouvelle version prête » avec bouton, jamais de rechargement forcé.
	let reloading = false;
	navigator.serviceWorker.addEventListener('controllerchange', () => {
		if (reloading) return;
		void pageIsCurrent(swUrl).then(current => {
			if (current || reloading) return;
			if (Date.now() - PAGE_LOADED_AT < 20000) {
				reloading = true;
				window.location.reload();
				return;
			}
			window.dispatchEvent(new CustomEvent('dtf:new-version'));
		});
	});
	navigator.serviceWorker
		.register(swUrl)
		.then(registration => {
			// onglet laissé ouvert des heures : on revérifie la version au retour sur l'onglet et toutes les 30 min
			const check = () => {
				registration.update().catch(() => undefined);
			};
			document.addEventListener('visibilitychange', () => {
				if (document.visibilityState === 'visible') check();
			});
			setInterval(check, 30 * 60 * 1000);
			registration.onupdatefound = () => {
				const installingWorker = registration.installing;
				if (installingWorker == null) {
					return;
				}
				installingWorker.onstatechange = () => {
					if (installingWorker.state === 'installed') {
						if (navigator.serviceWorker.controller) {
							// At this point, the updated precached content has been fetched,
							// but the previous service worker will still serve the older
							// content until all client tabs are closed.
							console.log(
								'New content is available and will be used when all ' +
									'tabs for this page are closed. See http://bit.ly/CRA-PWA.',
							);

							// Execute callback
							if (config && config.onUpdate) {
								config.onUpdate(registration);
							}
						} else {
							// At this point, everything has been precached.
							// It's the perfect time to display a
							// "Content is cached for offline use." message.
							console.log('Content is cached for offline use.');

							// Execute callback
							if (config && config.onSuccess) {
								config.onSuccess(registration);
							}
						}
					}
				};
			};
		})
		.catch(error => {
			console.error('Error during service worker registration:', error);
		});
}

function checkValidServiceWorker(swUrl: string, config: any) {
	// Check if the service worker can be found. If it can't reload the page.
	fetch(swUrl)
		.then(response => {
			// Ensure service worker exists, and that we really are getting a JS file.
			const contentType = response.headers.get('content-type');
			if (response.status === 404 || (contentType != null && contentType.indexOf('javascript') === -1)) {
				// No service worker found. Probably a different app. Reload the page.
				navigator.serviceWorker.ready.then(registration => {
					registration.unregister().then(() => {
						window.location.reload();
					});
				});
			} else {
				// Service worker found. Proceed as normal.
				registerValidSW(swUrl, config);
			}
		})
		.catch(() => {
			console.log('No internet connection found. App is running in offline mode.');
		});
}

export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready.then(registration => {
			registration.unregister();
		});
	}
}
